<div class="tt-dsi-container toro-component-shield-host" [ngClass]="{'is-today': isToday, 'has-issues': hasIssues}">
    <div class="tt-dsi-icon"><fa-icon [icon]="issuesIcon" [ngClass]="{'has-issues': hasIssues}"></fa-icon></div>
    <div class="tt-dsi-date">{{safetyItem.date.getDate()}}</div>
    <toro-component-shield [pTooltip]="tooltipText" tooltipPosition="top" ></toro-component-shield>
</div>
